import Vue from 'vue'

export async function getTarifas(context, [access_token]) {
    try {
        if (access_token) {
            context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'GET',
                url: '/tarifas',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            context.commit('tarifas/setTarifas', response.data.data, { root: true })
        }

    } catch (e) {
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}




export async function crearTarifa(context, [access_token, modelTarifa]) {
    try {

        if (access_token) {
           // context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'POST',
                url: '/tarifas',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelTarifa
            })
          
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
     //  context.commit('setLoading', false, { root: true })
    }
}

export async function updateTarifa(context, [access_token, modelTarifa]) {
    try {
        if (access_token) {
          
            const response = await Vue.axios({
                method: 'PUT',
                url: '/tarifas/' + modelTarifa.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelTarifa

            })
            if (response.status == 200) {
                context.commit('tarifas/actListTarifas', response.data.data, { root: true })
               }
           return response;
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
     // context.commit('setLoading', false, { root: true })
    }
}

export async function eliminarTarifa(context, [access_token, tarifa_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/tarifas/' + tarifa_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })

         
           if (response.status == 200) {
            context.commit('tarifas/actDeleteListTarifas', tarifa_id, { root: true })
           }
           return response;
          
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
      // context.commit('setLoading', false, { root: true })
    }
}





